import React, { Component } from 'react'
import L1ApproveReworkModalUI from './L1ApproveReworkModalUI'
import ReworkReasonModalSF from './ReworkReasonModalSF'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class L1ApproveReworkModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitting: false,
      successMsg: null,
      errorList: [],
      showReworkReasonModal: false
    }
  }

  onApproveClick = () => {
    if (this.state.submitting) return

    this.setState({
      successMsg: null,
      errorList: [],
      submitting: true
    })

    const loanId = this.props.loan.loanId

    RestApiUtils.post(
      this.props.context,
      `/api/disbursement-checklist/${loanId}/l1-approve`,
      this.onSubmitCallback,
      null,
      null
    )
  }

  onReworkClick = () => {
    // Show the rework reason modal
    this.setState({ showReworkReasonModal: true })
  }

  onCloseReworkReasonModal = () => {
    this.setState({ showReworkReasonModal: false })
  }

  onReworkReasonSuccess = () => {
    this.setState({ showReworkReasonModal: false })

    // Call parent success handler
    if (this.props.onSuccess) {
      this.props.onSuccess()
    } else {
      this.props.onCancelClick()
    }
  }

  onSubmitCallback = (response) => {
    const errorList = []

    if (response.errorList && response.errorList.length > 0) {
      response.errorList.forEach(error => {
        errorList.push(error.message || error)
      })
    }

    this.setState({
      successMsg: response.success || response.message || null,
      errorList: errorList,
      submitting: false
    })

    if (errorList.length === 0 && (response.success || response.checklist)) {
      setTimeout(() => {
        if (this.props.onSuccess) {
          this.props.onSuccess()
        } else {
          this.props.onCancelClick()
        }
      }, 1500)
    }
  }

  render() {
    const { submitting, successMsg, errorList, showReworkReasonModal } = this.state

    return (
      <>
        <L1ApproveReworkModalUI
          title="L1 Approve/Rework"
          onApproveClick={this.onApproveClick}
          onReworkClick={this.onReworkClick}
          onCancelClick={this.props.onCancelClick}
          submitting={submitting}
          successMsg={successMsg}
          errorList={errorList}
          loan={this.props.loan}
        />

        {showReworkReasonModal && (
          <ReworkReasonModalSF
            context={this.props.context}
            loan={this.props.loan}
            title="L1 Rework Reason"
            apiEndpoint={`/api/disbursement-checklist/${this.props.loan.loanId}/l1-rework`}
            onSuccess={this.onReworkReasonSuccess}
            onCancelClick={this.onCloseReworkReasonModal}
          />
        )}
      </>
    )
  }
}

export default L1ApproveReworkModalSF